import { all } from 'redux-saga/effects';
import './auth';
import './users';
import './activation';
import './company';
import './enums';
import './orders';
import './priceEntries';
import './questionnaire';
import './businessInfo';

angular.module('tct.sagas', ['tct.sagas.auth',
  'tct.sagas.users',
  'tct.sagas.activation',
  'tct.sagas.company',
  'tct.sagas.enums',
  'tct.sagas.orders',
  'tct.sagas.priceLists',
  'tct.sagas.questionnaire',
  'tct.sagas.businessInfo',
])
  .factory('sagaFactory', sagaFactory);

sagaFactory.$inject = ['authSagaFactory',
  'usersSagaFactory',
  'activationSagaFactory',
  'companySagaFactory',
  'enumSagaFactory',
  'ordersSagaFactory',
  'priceListsSagaFactory',
  'questionnaireSagaFactory',
  'businessInfoSagaFactory',
];

function sagaFactory(authSagaFactory,
  usersSagaFactory,
  activationSagaFactory,
  companySagaFactory,
  enumSagaFactory,
  ordersSagaFactory,
  priceListsSagaFactory,
  questionnaireSagaFactory,
  businessInfoSagaFactory,
) {
  const factory = {
    rootSaga,
  };

  return factory;

  function* rootSaga() {
    yield all([
      activationSagaFactory.activationFlow(),
      authSagaFactory.loginFlow(),
      authSagaFactory.resetPasswordFlow(),
      authSagaFactory.requestResetPasswordFlow(),
      authSagaFactory.changePasswordFlow(),
      usersSagaFactory.usersFlow(),
      companySagaFactory.companyListFlow(),
      companySagaFactory.companyFlow(),
      companySagaFactory.businessInfoFlow(),
      companySagaFactory.businessInfoOrderFlow(),
      companySagaFactory.companyStructureFlow(),
      companySagaFactory.techDocsFlow(),
      companySagaFactory.techDocListFlow(),
      companySagaFactory.techDocUpdateFlow(),
      companySagaFactory.techDocSaveFlow(),
      companySagaFactory.createTechDocFlow(),
      companySagaFactory.updateBusinessInfoNotesFlow(),
      companySagaFactory.createCompanyFlow(),
      companySagaFactory.updateBusinessInfoStatusFlow(),
      companySagaFactory.searchCompanyFlow(),
      companySagaFactory.removeTechDocFlow(),
      companySagaFactory.companyContractsFlow(),
      companySagaFactory.companyBudgetsFlow(),
      enumSagaFactory.enumsFlow(),
      authSagaFactory.localeFlow(),
      ordersSagaFactory.ordersFlow(),
      priceListsSagaFactory.getItalianEntriesFlow(),
      priceListsSagaFactory.getForeignEntriesFlow(),
      priceListsSagaFactory.getDefaultPriceListFlow(),
      questionnaireSagaFactory.questionnaireFlow(),
      questionnaireSagaFactory.assignContactFlow(),
      businessInfoSagaFactory.businessInfoFlow(),
    ]);
  }
}
